// OTP verify lockout (auth-triggers Lambda): 3 wrong codes → Dynamo
// locked_until (UTC ISO). CreateAuthChallenge throws OTP_LOCKED with that
// until=… when a new code is requested while locked.
//
// confirmSignIn after max attempts (or an expired challenge) surfaces a
// tokenless NotAuthorizedException — that is NOT proof of lockout. Bounce
// to login and ask for a new code; the next CreateAuthChallenge will return
// OTP_LOCKED until=… if Dynamo still holds the lock.

export const OTP_LOCKED_TOKEN = "OTP_LOCKED";
export const OTP_LOCKOUT_MS = 60 * 60 * 1000;
export const AUTH_SESSION_ENDED_USER_MESSAGE =
  "Your sign-in session ended. Please request a new code.";

const UNTIL_RE =
  /OTP_LOCKED(?:\s+until=(\d{4}-\d{2}-\d{2}T[\d:.]+(?:Z|[+-]\d{2}:?\d{2})?))?/;

export const hasOtpLockedToken = (err) =>
  String(err?.message || err || "").includes(OTP_LOCKED_TOKEN);

/** Confirmed lockout only — never infer from a bare NotAuthorizedException. */
export const isOtpLockoutError = (err) => hasOtpLockedToken(err);

/** Cognito ended the custom-auth challenge (max attempts or expired session). */
export const isAuthSessionEndedError = (err) =>
  err?.name === "NotAuthorizedException" && !hasOtpLockedToken(err);

/** Parse locked_until from a Cognito/Lambda error message, if present. */
export const parseOtpLockUntil = (err) => {
  const msg = String(err?.message || err || "");
  const m = msg.match(UNTIL_RE);
  if (!m?.[1]) return null;
  const t = Date.parse(m[1]);
  return Number.isFinite(t) ? new Date(t) : null;
};

/**
 * Unlock instant for the alert: prefer server UTC until; otherwise assume
 * the lock window just started (OTP_LOCKED without until= during rollout).
 */
export const resolveOtpLockUntil = (err, now = Date.now()) =>
  parseOtpLockUntil(err) || new Date(now + OTP_LOCKOUT_MS);

/** User-facing copy with unlock time in the browser's local timezone. */
export const formatOtpLockUserMessage = (untilDate) => {
  const when = (
    untilDate instanceof Date ? untilDate : new Date(untilDate)
  ).toLocaleString(undefined, {dateStyle: "short", timeStyle: "short"});
  return `Too many incorrect codes. Sign-in is locked until ${when}.`;
};
